import InternalAnchor from './Anchor';
import AnchorLink from './AnchorLink';
export { AnchorProps } from './Anchor';
export { AnchorLinkProps } from './AnchorLink';
const Anchor = InternalAnchor;
Anchor.Link = AnchorLink;
export default Anchor;
